var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { MedFile } from '../../../../media/values/medFile/MedFile';
export class MedSeqFile {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get at() {
        return this.parent;
    }
    get medSeq() {
        return this.at.trait.value;
    }
    get medFileAt() {
        const [at] = this.at.aspect.activeTraits.filter(at => at.trait.value && at.trait.value instanceof MedFile && at.trait.value.mediumLabel === this.medSeq.mediumLabel);
        return at;
    }
    get medFile() {
        return (this.medFileAt && this.medFileAt.trait.value) || undefined;
    }
}
__decorate([
    computed
], MedSeqFile.prototype, "medFileAt", null);
